import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorScreenProps,
} from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { RoutineStoreCustomizeSections } from "./RoutineStoreCustomizeSections";
import { useDefaultScreenOptions } from "@/src/common/navigationHeaderOptions";
import { RoutineStoreCustomizeProvider } from "./State";
import { RoutineStoreCustomizeSectionsSection } from "./RoutineStoreCustomizeSectionsSection";

type RoutineStoreCustomizeStackParamList = {
  RoutineStoreCustomizeSections: {
    routineId: string;
    storeId?: string;
  };
  RoutineStoreCustomizeSectionsSection: {
    routineId: string;
    storeId?: string;
    sectionId: string;
  };
};
const Stack = createNativeStackNavigator<RoutineStoreCustomizeStackParamList>();
export type RoutineStoreCustomizeType<
  T extends keyof RoutineStoreCustomizeStackParamList,
> = {
  route: RouteProp<RoutineStoreCustomizeStackParamList, T>;
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<RoutineStoreCustomizeStackParamList, T>,
    UserLoggedInNavigatorNavigationProp<"RoutineStoreCustomize">
  >;
};
export const RoutineStoreCustomize = withWebModal(InnerRoutineStoreCustomize);
function InnerRoutineStoreCustomize(
  props: UserLoggedInNavigatorScreenProps<"RoutineStoreCustomize">
) {
  const screenOptions = useDefaultScreenOptions();
  return (
    <RoutineStoreCustomizeProvider>
      <Stack.Navigator screenOptions={screenOptions}>
        <Stack.Screen
          name="RoutineStoreCustomizeSections"
          component={RoutineStoreCustomizeSections}
          initialParams={{
            routineId: props.route.params.routineId,
            storeId: props.route.params.storeId,
          }}
        />
        <Stack.Screen
          name="RoutineStoreCustomizeSectionsSection"
          component={RoutineStoreCustomizeSectionsSection}
          initialParams={{
            routineId: props.route.params.routineId,
            storeId: props.route.params.storeId,
          }}
        />
      </Stack.Navigator>
    </RoutineStoreCustomizeProvider>
  );
}
